module.exports = __webpack_public_path__ + "static/media/plane.806fec64.svg";